/* eslint-disable import/prefer-default-export, react/prop-types */
import "../../src/styles/index.scss";
import React from "react";
import Main from "../../src/layouts/Main";
import AuthGuard from "../../src/components/AuthGuard";
import { AuthContextProvider } from "../../src/components/auth-context";

export const wrapRootElement = ({ element }) => (
    <AuthContextProvider>{element}</AuthContextProvider>
  );

export const wrapPageElement = ({ element, props }) => {
    const withLayout = <Main {...props}>{element}</Main>;
    return <AuthGuard element={withLayout} props={props} />;
};
